import { createStyle } from '@gluestack-style/react';

export const PopoverArrow = createStyle({});
